// extracted by mini-css-extract-plugin
export default {"newsHeader":"newsHeader_newsHeader__-5lMt","newsHeaderImg":"newsHeader_newsHeaderImg__R9X2U","newsHeaderImg2":"newsHeader_newsHeaderImg2__6IRn8"};